export const getEventRegistrationURL = code =>
    `${window.location.protocol}//${window.location.hostname}/event-registration/${code}`;

export const getEventRegisteredURL = code =>
    `${window.location.protocol}//${window.location.hostname}/my-icsc/events/${code}`;

export const getTrusteeEventRegisteredURL = code =>
    `${window.location.protocol}//${window.location.hostname}/my-icsc/trustees/${code}`;
